var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider"},[_c('input',{staticClass:"slider-input",attrs:{"type":"range","min":_vm.options.length !== 0 ? 0 : _vm.min,"max":_vm.options.length !== 0 ? _vm.options.length - 1 : _vm.max,"disabled":_vm.disabled},domProps:{"value":_vm.options.length !== 0 ? _vm.options.indexOf(_vm.value) : _vm.value},on:{"input":($event) =>
        _vm.$emit('input', _vm.getSelectedOption(parseInt($event.target.value)))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }